import { Box, type SxProps, type Theme, Typography } from "@mui/material";
import type { FC, ReactNode } from "react";
import { FONT_SIZE, INK } from "@/theme/tokens";
import { JumpingDots } from "../Animations/JumpingDots";

type Props = {
	text?: string;
	/** Replaces the JumpingDots, e.g. with the assistant's own thinking avatar. Decorative: it is `aria-hidden`. */
	// DEFAULT: absent renders the JumpingDots, so every existing chat surface keeps its indicator.
	leading?: ReactNode;
	dataTestId?: string;
	sx?: SxProps<Theme>;
};

/**
 * The streaming "assistant is thinking" line for a chat message column:
 * JumpingDots (or a custom leading visual) with an optional italic muted status label, leading-aligned.
 */
export const ChatThinkingIndicator: FC<Props> = ({ text, leading, dataTestId, sx }) => (
	<Box data-testid={dataTestId} sx={[{ display: "flex", alignItems: "center", gap: 1, px: 0.5 }, ...(Array.isArray(sx) ? sx : [sx])]}>
		{/* Purely decorative motion — the status text carries the meaning and is announced by the parent log. */}
		<Box component="span" aria-hidden sx={{ display: "inline-flex" }}>
			{leading ?? <JumpingDots />}
		</Box>
		{text && <Typography sx={{ fontSize: FONT_SIZE.SECONDARY, color: INK.MUTED, fontStyle: "italic" }}>{text}</Typography>}
	</Box>
);
